import { render, staticRenderFns } from "./lyric.vue?vue&type=template&id=4b8aa880&"
import script from "./lyric.vue?vue&type=script&lang=js&"
export * from "./lyric.vue?vue&type=script&lang=js&"
import style0 from "./lyric.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports